import * as React from "react";
import {FontAwesomeIcon}    from "@fortawesome/react-fontawesome";
import "./product-carousel.scss";

export const ProductCarousel = ({themeScheme, products}) => {
    const [indexProduct, setIndexProduct] = React.useState(0)
    const [shouldIncrementProduct, setShouldIncrementProduct] = React.useState(true)

    const { height, width } = useWindowDimensions()
    const productOffset = productCarouselLength(width)

    const incrementProduct = () => {
        let index = indexProduct + 1
        if(index > products.length - productOffset) {
            index = 0
        }
        setIndexProduct(index)
    }

    const decrementProduct = () => {
        let index = indexProduct - 1
        if(index < 0) {
            index = products.length - productOffset
        }
        setIndexProduct(index)    
    } 

    React.useEffect(() => {
        const interval = setInterval(() => {
            if(shouldIncrementProduct) {
                incrementProduct()
            }
        }, DURATION_CAROUSEL_POSITION)

        return () => clearInterval(interval)
    })

    return (
        <div
            className="products-carousel-br22"
            onMouseEnter={() => {setShouldIncrementProduct(false)}}
            onMouseLeave={() => {setShouldIncrementProduct(true)}}
        >

            {(width > MIN_WIDTH_CARET_VISIBLE) &&
                <FontAwesomeIcon
                    icon={require('@fortawesome/free-solid-svg-icons')['faCaretDown']}
                    className='icon-caret'
                    onClick={() => decrementProduct()}
                    style={{
                        color: themeScheme?.xpresso?.menuBackgroundColor
                    }}
                    xd-qa-type="button"
                    xd-qa-name="Back Arrow"
                />
            }
           
            <div className="carousel">
                {
                    products.map((product, i) => (
                        <div
                            key={i}
                            className="product"
                            style={{ 
                                translate: `${-100 * indexProduct}%`
                            }}
                        >
                            <div className="image-container">
                                <img src={product.source} alt={product.header} xd-qa-type="image" xd-qa-name={"Image " + i}/>
                            </div>
                            <p xd-qa-type="label" xd-qa-name="Product Header">{product.header}</p> 
                        </div>
                    ))
                }
            </div>
            {(width > MIN_WIDTH_CARET_VISIBLE) &&
                <FontAwesomeIcon
                    icon={require('@fortawesome/free-solid-svg-icons')['faCaretUp']}
                    className='icon-caret'
                    onClick={() => incrementProduct()}
                    style={{
                        color: themeScheme?.xpresso?.menuBackgroundColor
                    }}
                    xd-qa-type="button"
                    xd-qa-name="Forward Arrow"
                />
            }

        </div>
    )

}

const windowDimensions = ()  => {
    const { innerWidth: width, innerHeight: height } = window
    return {
      width,
      height
    }
}

const useWindowDimensions = () => {
    const [dimensions, setDimensions] = React.useState(windowDimensions())
  
    React.useEffect(() => {
        const handleResize = () => {
            setDimensions(windowDimensions());
    }
  
      window.addEventListener('resize', handleResize)
      return () => window.removeEventListener('resize', handleResize)
    }, [])
  
    return dimensions
}

const productCarouselLength = (width) => {
    const THREE_PRODUCT_LIMIT = 1800
    const TWO_PRODUCT_LIMIT = 800
    if(width > THREE_PRODUCT_LIMIT) {
        return 3
    }
    if(width > TWO_PRODUCT_LIMIT) {
        return 2
    }
    return 1
}

const DURATION_CAROUSEL_POSITION = 4000
const MIN_WIDTH_CARET_VISIBLE = 479